import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import style from "./style";
import CustomLink from "../CustomLink";
import { RichText } from "prismic-reactjs";
import Image from "next/image";

const Member = ({ classes, data }) => {
  return (
    <Container className={classes.aboutProfileWrapper}>
      <div className="aboutProfile">
        <img className="profileImg" src={data.portrait_image.url} />
        <div className="profileDetails">
          <div className="name">{RichText.asText(data.name)}</div>
          <div className="role">{RichText.asText(data.title)}</div>
          <div className="about">{RichText.render(data.full_bio)}</div>
        </div>
      </div>
    </Container>
  );
};

Member.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default withStyles(style)(Member);
